import { InputFlowArg } from '@lighthouse/core'
import { generateArgVariableValue } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'

import { actionWorker } from '..'
import { ExecuteActionParams } from '../type'

export const handleAction = async (config: InputFlowArg, params: ExecuteActionParams) => {
    const { workflowList } = params
    const { flowId, args } = config
    const flowData = workflowList?.find(w => w.id === flowId)

    if (!flowData) {
        return { type: 'interrupted', success: true }
    }

    // 必须要启用才可以执行
    if (!flowData?.enabled) {
        return { type: 'interrupted', success: true }
    }
    const invokeId = nanoid()
    params.workflow = flowData
    // 设置工作流数据到jobQueues, queues
    actionWorker.sequenceWorker(flowData)
    const triggerArgs = args?.map(arg => {
        return generateArgVariableValue(arg, params)
    })

    actionWorker.injectRuntimeParams(invokeId, {
        ...params,
        triggerArgs
    })
    const endArgs = await actionWorker.invokeFlow(flowData.id, invokeId)

    return { type: 'args', success: true, data: endArgs }
}
